import * as api from "../api/index";

// Action Types
export const CREATE_QRCODE = "CREATE_QRCODE";
export const GET_QRCODES = "GET_QRCODES";
export const GET_QRCODE = "GET_QRCODE";
export const UPDATE_QRCODE = "UPDATE_QRCODE";
export const DELETE_QRCODE = "DELETE_QRCODE";
export const GET_QRCODE_STATISTICS = "GET_QRCODE_STATISTICS";
export const GENERATE_CONTENT_PREVIEW = "GENERATE_CONTENT_PREVIEW";
export const SET_QRCODE_ERROR = "SET_QRCODE_ERROR";

// Action Creators
export const createQRCode = (qrCodeData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.createQRCode(qrCodeData);
    dispatch({ type: CREATE_QRCODE, payload: data });
    openSnackbar("QR Code created successfully");
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Error creating QR Code";
    openSnackbar(message);
    dispatch({ type: SET_QRCODE_ERROR, payload: message });
    throw error;
  }
};

export const getQRCodes = (query, page) => async (dispatch) => {
  try {
    const { data } = await api.getQRCodes(query, page);
    dispatch({ type: GET_QRCODES, payload: data });
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Error fetching QR Codes";
    dispatch({ type: SET_QRCODE_ERROR, payload: message });
    throw error;
  }
};

export const getQRCode = (id) => async (dispatch) => {
  try {
    const { data } = await api.getQRCode(id);
    dispatch({ type: GET_QRCODE, payload: data });
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Error fetching QR Code";
    dispatch({ type: SET_QRCODE_ERROR, payload: message });
    throw error;
  }
};

export const updateQRCode = (id, qrCodeData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateQRCode(id, qrCodeData);
    dispatch({ type: UPDATE_QRCODE, payload: data });
    openSnackbar("QR Code updated successfully");
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Error updating QR Code";
    openSnackbar(message);
    dispatch({ type: SET_QRCODE_ERROR, payload: message });
    throw error;
  }
};

export const deleteQRCode = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteQRCode(id);
    dispatch({ type: DELETE_QRCODE, payload: id });
    openSnackbar("QR Code deleted successfully");
  } catch (error) {
    const message = error?.response?.data?.message || "Error deleting QR Code";
    openSnackbar(message);
    dispatch({ type: SET_QRCODE_ERROR, payload: message });
    throw error;
  }
};

export const getQRCodeStatistics = () => async (dispatch) => {
  try {
    const { data } = await api.getQRCodeStatistics();
    dispatch({ type: GET_QRCODE_STATISTICS, payload: data });
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Error fetching statistics";
    dispatch({ type: SET_QRCODE_ERROR, payload: message });
    throw error;
  }
};

export const generateContentPreview = (type, content) => async (dispatch) => {
  try {
    const { data } = await api.generateContentPreview({ type, content });
    dispatch({ type: GENERATE_CONTENT_PREVIEW, payload: data });
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Error generating preview";
    dispatch({ type: SET_QRCODE_ERROR, payload: message });
    throw error;
  }
};
